export default __webpack_public_path__ + "static/media/individual-2.8acd2edb.webp";